// extracted by mini-css-extract-plugin
export var container = "_db-0";
export var containerTopRight = "_db-1";